import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { NgxPermissionsGuard } from "ngx-permissions";
import { AuthGuard, CanDeactivateGuard } from "../core/guards/auth.guard";
import { AgreementModelComponent } from "./profile/agreement-pt2-grid/agreement-model/agreement-model.component";
import { ProfileComponent } from "./profile/profile.component";

const routes: Routes = [
  {
    path: 'dashboard', 
    loadChildren: () => import('./dashboards/dashboards.module').then(m => m.DashboardsModule),
    canLoad: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: '-9990',
        redirectTo: 'error/404'
      },
    }
  },
  {
    path: 'brokers', 
    loadChildren: () => import('./broker/broker.module').then(m => m.BrokerModule),
    canLoad: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: '-9938',
        redirectTo: 'error/404'
      },
    }
  },
   {
    path: 'underwriter', 
    loadChildren: () => import('./under-writer/under-writer.module').then(m => m.UnderWriterModule),
    canLoad: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: '-9937',
        redirectTo: 'error/404'
      },
    }
  },
  {
    path: 'clients', 
    loadChildren: () => import('./client/client.module').then(m => m.ClientModule),
    canLoad: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: '-9936',
        redirectTo: 'error/404'
      },
    }
  },
  {
    path: 'case', 
    loadChildren: () => import('./case/case.module').then(m => m.CaseModule),
    canLoad: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: '-9934',
        redirectTo: 'error/404'
      },
    }
  },
   {
    path: 'unallocated-cash-bank-account', 
    loadChildren: () => import('./unallocated-cash-bank-account/unallocated-cash-bank-account.module').then(m => m.UnallocatedCashModule),
    canLoad: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: '-9927',
        redirectTo: 'error/404'
      },
    }
  },
  {
    path: 'outstanding-balance', 
    loadChildren: () => import('./outstanding-balance/outstanding-balance.module').then(m => m.OutstandingBalanceModule),
    canLoad: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: '-9923',
        redirectTo: 'error/404'
      },
    }
  },
  {
    path: 'holding-account-bank-account', 
    loadChildren: () => import('./holding-account-bank-account/holding-account-bank-account.module').then(m => m.HoldingAccountModule),
    canLoad: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: '-9928',
        redirectTo: 'error/404'
      },
    }
  },
  {
    path: 'client-payment', 
    loadChildren: () => import('./client-payment/client-payment.module').then(m => m.ClientPaymentModule),
    canLoad: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: '-9926',
        redirectTo: 'error/404'
      },
    }
  },
   {
    path: 'client-account', 
    loadChildren: () => import('./client-account/client-account.module').then(m => m.ClientAccountModule),
    canLoad: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: '-9929',
        redirectTo: 'error/404'
      },
    }
  },
  {
    path: 'bank-reconciliation', 
    loadChildren: () => import('./bank-reconciliation/bank-reconciliation.module').then(m => m.BankReconciliationModule),
    canLoad: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: '-9930',
        redirectTo: 'error/404'
      },
    }
  },
   {
    path: 'invoice-post', 
    loadChildren: () => import('./invoice-post/invoice-post.module').then(m => m.InvoicePostModule),
    canLoad: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: '-9935',
        redirectTo: 'error/404'
      },
    }
  },
  {
    path: 'invoice', 
    loadChildren: () => import('./invoice/invoice.module').then(m => m.InvoiceModule),
    canLoad: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: '-9933',
        redirectTo: 'error/404'
      },
    }
  },
  {
    path: 'group-invoices', 
    loadChildren: () => import('./group-invoices/group-invoices.module').then(m => m.GroupInvoicesModule),
    canLoad: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: '-9922',
        redirectTo: 'error/404'
      },
    }
  },
  {
    path: 'users', 
    loadChildren: () => import('./admin/users/user.module').then(m => m.UserModule),
    canLoad: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: '-9987',
        redirectTo: 'error/404'
      },
    }
  },
  {
    path: 'login-analysis', 
    loadChildren: () => import('./admin/login-analysis/login-analysis.module').then(m => m.LoginAnalysisModule),
    canLoad: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: '-9986',
        redirectTo: 'error/404'
      },
    }
  },
  {
    path: 'system-settings', 
    loadChildren: () => import('./admin/system-settings/system-settings.module').then(m => m.SystemSettingsModule),
    canLoad: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: '-9985',
        redirectTo: 'error/404'
      },
    }
  },
  {
    path: 'export-log',
    loadChildren: () => import('./admin/export-log/export-log.module').then(m => m.ExportLogModule),
    canLoad: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: '-9984',
        redirectTo: 'error/404'
      },
    }
  },
  {
    path: 'email',
    loadChildren: () => import('./admin/email/email.module').then(m => m.EmailModule),
    canLoad: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: '-9981',
        redirectTo: 'error/404'
      },
    }
  },
  {
    path: 'email-template',
    loadChildren: () => import('./admin/email-template/email-template.module').then(m => m.EmailTemplateModule),
    canLoad: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: '-9982',
        redirectTo: 'error/404'
      },
    }
  },
  {
    path: 'agreement',
    loadChildren: () => import('./admin/agreement/agreement.module').then(m => m.AgreementModule),
    canLoad: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: '-9978',
        redirectTo: 'error/404'
      },
    }
  },
  {
    path: 'system-alerts',
    loadChildren: () => import('./admin/system-alerts/system-alerts.module').then(m => m.SystemAlertsModule),
    canLoad: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: '-9979',
        redirectTo: 'error/404'
      },
    }
  },
  {
    path: 'system-administration',
    loadChildren: () => import('./admin/system-administration/system-administration.module').then(m => m.SystemAdministrationModule),
    canLoad: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: '-9945',
        redirectTo: 'error/404'
      },
    }
  },
  {
    path: 'invalid-email-log',
    loadChildren: () => import('./admin/invalid-email-log/invalid-email-log.module').then(m => m.InvalidEmailLogModule),
    canLoad: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: '-9943',
        redirectTo: 'error/404'
      },
    }
  },
  {
    path: 'safe-ips',
    loadChildren: () => import('./admin/safe-ips/safe-ips.module').then(m => m.SafeIpsModule),
    canLoad: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: '-9942',
        redirectTo: 'error/404'
      },
    }
  },
  {
    path: 'templates',
    loadChildren: () => import('./maintenance/template/template.module').then(m => m.TemplateModule),
    canLoad: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: '-9989',
        redirectTo: 'error/404'
      },
    }
  },
  {
    path: 'lookups',
    loadChildren: () => import('./maintenance/lookup/lookup.module').then(m => m.LookupModule),
    canLoad: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: '-9988',
        redirectTo: 'error/404'
      },
    }
  },
  {
    path: 'bank-accounts',
    loadChildren: () => import('./maintenance/bank-accounts/bank-accounts.module').then(m => m.BankaccountModule),
    canLoad: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: '-9932',
        redirectTo: 'error/404'
      },
    }
  },
  {
    path: 'bank-import',
    loadChildren: () => import('./bank-account-import/bank-account-import.module').then(m => m.BankAccountImportModule),
    canLoad: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: '-9931',
        redirectTo: 'error/404'
      },
    }
  },
  {
    path: 'profile',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: ProfileComponent,
        canDeactivate: [CanDeactivateGuard]
      },
      {
        path: 'view-agreement',
        component: AgreementModelComponent,
        canDeactivate: [CanDeactivateGuard]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
exports: [RouterModule],
})
export class PagesRoutingModule { }
